import React from "react";
import { useTheme } from "styled-components";

import { CSSGrid } from "@components/Layout/CssGrid";

import { CustomizeTaste } from "./CustomizeTaste";
import { EasyManageable } from "./EaseManageable";

const areas = CSSGrid.areas({
  CustomizeTaste,
  EasyManageable,
});

areas.all(({ CustomizeTaste, EasyManageable }, { repeat }) => [
  repeat(CustomizeTaste, 12),
  repeat(EasyManageable, 12),
]);

areas.smallTablet(({ CustomizeTaste, EasyManageable }, { repeat, compose }) => [
  compose(repeat(CustomizeTaste, 6), repeat(EasyManageable, 6)),
]);

export const Bento6x6: React.FC<{ language: string }> = ({ language }) => {
  const theme = useTheme();

  return (
    <CSSGrid
      rowGap={theme.spacing.spacing_24}
      areas={areas}
      areasProps={{
        CustomizeTaste: { language },
        EasyManageable: { language },
      }}
    />
  );
};
